// src/components/pdf/utils/refUtils.js
import { refs } from '../../../data/refs';

/**
 * Récupère le libellé français d'un classement depuis refs.js
 * @param {string} code - Code du classement (ex: "36")
 * @returns {string} Label français (ex: "30")
 */
export const getClassementLabel = (code) => {
  if (!code) return '-';
  
  // Convertir en string et nettoyer
  const codeStr = String(code).trim();
  
  // Chercher dans refs
  const item = refs.refClassement.find(r => r.code === codeStr);
  
  // Debug si non trouvé
  if (!item) {
    console.warn(`⚠️ Classement non trouvé: "${codeStr}" (type: ${typeof code})`);
    return codeStr;  // Retourner le code tel quel si non trouvé
  }
  
  return item.labelFr;
};

/**
 * Récupère le libellé français d'un pays depuis refs.js
 * @param {string} code - Code du pays (ex: "FRA")
 * @returns {string} Label français (ex: "France")
 */
export const getPaysLabel = (code) => {
  if (!code) return '-';
  const item = refs.refPays.find(r => r.code === code);
  return item ? item.labelFr : code;
};

/**
 * Récupère le libellé français d'une surface depuis refs.js
 * @param {string} code - Code de la surface (ex: "DI")
 * @returns {string} Label français (ex: "Dur intérieur")
 */
export const getSurfaceLabel = (code) => {
  if (!code) return '-';
  const item = refs.refSurface.find(r => r.code === code);
  return item ? item.labelFr : code;
};

/**
 * Récupère le libellé français d'une catégorie depuis refs.js
 * @param {string} code - Code de la catégorie (ex: "1")
 * @returns {string} Label français (ex: "Tournoi amateur")
 */
export const getCategorieLabel = (code) => {
  if (!code) return '-';
  
  // Convertir en string et nettoyer
  const codeStr = String(code).trim();
  
  // Chercher dans refs
  const item = refs.refCategorie.find(r => r.code === codeStr);
  
  // Debug si non trouvé
  if (!item) {
    console.warn(`⚠️ Catégorie non trouvée: "${codeStr}" (type: ${typeof code})`);
    return codeStr;
  }
  
  return item.labelFr;
};

/**
 * Récupère le libellé français d'un tour depuis refs.js
 * @param {string} code - Code du tour (ex: "V8")
 * @returns {string} Label français (ex: "1/2 de finale")
 */
export const getTourLabel = (code) => {
  if (!code) return '-';
  const item = refs.refTour.find(r => r.code === code);
  return item ? item.labelFr : code;
};

/**
 * Récupère le libellé français d'une catégorie d'âge depuis refs.js
 * @param {string} code - Code de la catégorie (ex: "U16")
 * @returns {string} Label français (ex: "Moins de 16 ans")
 */
export const getCategorieAgeLabel = (code) => {
  if (!code) return '-';
  const item = refs.refCategorieAge.find(r => r.code === code);
  return item ? item.labelFr : code;
};

/**
 * Récupère le libellé français d'une épreuve depuis refs.js
 * @param {string} code - Code de l'épreuve (ex: "SM")
 * @returns {string} Label français (ex: "Simple Messieurs")
 */
export const getEpreuveLabel = (code) => {
  if (!code) return '-';
  const item = refs.refEpreuve.find(r => r.code === code);
  return item ? item.labelFr : code;
};